module.exports = __webpack_public_path__ + "img/d200907-3.1cddfb37.jpg";